import { CommonApi } from '../../../api/server';
import { BillingCountryModel, BillingCountryModelsC } from '../interfaces/billing-country-model';
import { CreateBillingCardForm } from '../interfaces/create-billing-card-form';
import { PaymentSourcesModel, PaymentSourcesModelC } from '../interfaces/payment-sources-model';


function getPaymentMethods(): Promise<PaymentSourcesModel> {
  return CommonApi.getV(
    `/user/billing`,
    PaymentSourcesModelC,
    'Error while fetch payment methods',
  );
}

function createPaymentMethod(paymentMethod: CreateBillingCardForm): Promise<PaymentSourcesModel> {
  return CommonApi.postV(
    `/user/billing`,
    paymentMethod,
    PaymentSourcesModelC,
    'Error while create new payment method',
  );
}

function setPrimaryPaymentMethod(methodId: string): Promise<PaymentSourcesModel> {
  return CommonApi.putV(
    `/user/billing/${methodId}/primary`,
    null,
    PaymentSourcesModelC,
    `Error while set payment method ${methodId} as primary`,
  );
}

function setBackupPaymentMethod(methodId: string): Promise<PaymentSourcesModel> {
  return CommonApi.putV(
    `/user/billing/${methodId}/backup`,
    null,
    PaymentSourcesModelC,
    `Error while set payment method ${methodId} as backup`,
  );
}

function deletePaymentMethod(methodId: string): Promise<PaymentSourcesModel> {
  return CommonApi.deleteV(
    `/user/billing/${methodId}`,
    null,
    PaymentSourcesModelC,
    `Error while set payment method ${methodId} as backup`,
  );
}

function getAvailableBillingCountries(): Promise<BillingCountryModel[]> {
  return CommonApi.getV(
    `/billing/available-countries`,
    BillingCountryModelsC,
    'Error while get available countries',
  );
}


export const PaymentMethodsApi = {
  getPaymentMethods,
  createPaymentMethod,
  setPrimaryPaymentMethod,
  setBackupPaymentMethod,
  deletePaymentMethod,
  getAvailableBillingCountries,
};
